import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimateOnScrollDirective } from './animate-on-scroll.directive';
import { SearchInfographicsComponent } from './search-infographics/search-infographics.component';
//import { InsightsInfographicsComponent } from './insights-infographics/insights-infographics.component';
import { ExportInfographicsComponent } from './export-infographics/export-infographics.component';
import { InfographicsComponent } from './infographics.component';
import { InfographicsModalComponent } from './infographics-modal/infographics-modal.component';

@NgModule({
    imports: [CommonModule],
    declarations: [
      SearchInfographicsComponent,
     // InsightsInfographicsComponent,
      ExportInfographicsComponent,
      InfographicsComponent,
      AnimateOnScrollDirective,
      InfographicsModalComponent
    ],
    exports: [
      SearchInfographicsComponent,
     // InsightsInfographicsComponent,
      ExportInfographicsComponent,
      InfographicsComponent,
      AnimateOnScrollDirective,
      InfographicsModalComponent
    ],
})
export class InfographicsModule {}
